// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"43":"customer-analysis","158":"order-analysis"}[chunkId] + "." + {"43":"1fa9c406","158":"1fa9c406"}[chunkId] + ".css";
};